export default __webpack_public_path__ + "static/media/23.949641b3.png";